import axios from 'axios';

const newKey = () => {
  const crypto = window.crypto;
  if (crypto?.randomUUID) return crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (crypto?.getRandomValues) crypto.getRandomValues(bytes);
  else bytes.forEach((_, index) => { bytes[index] = Math.floor(Math.random() * 256); });
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const createQuotationAttempt = () => {
  let key = newKey();
  let body = null;
  return {
    reset() {
      key = newKey();
      body = null;
    },
    async post(payload, config = {}) {
      const nextBody = JSON.stringify(payload);
      // Editing the request after an uncertain outcome starts a distinct create.
      if (body !== null && body !== nextBody) this.reset();
      body = nextBody;
      try {
        const response = await axios.post('/api/quotations', payload, {
          ...config,
          headers: { ...config.headers, 'Idempotency-Key': key },
        });
        this.reset();
        return response;
      } catch (error) {
        // Only a response-less failure can have committed without our knowing.
        if (error.response) this.reset();
        throw error;
      }
    },
  };
};
